<div class="family-product-list">

  <header [class.empty]="(insuranceResults$ | async)?.count === 0"
          [class.nonEmpty]="(insuranceResults$ | async)?.count > 0">
    <div class="icon">
      <i class="fa fa-circle"></i>
    </div>
    <h2 class="title">{{familyLabel}}</h2>
    <div class="left-subtitle" *ngIf="showLeftSubtitle">
      <a [routerLink]="['/mandate', {family:family}]"
         class="mandate-link mandate-request-action-button"
      >
        <span i18n>Transférer</span>
      </a>
    </div>
    <div class="filler"></div>
    <div class="subtitle" *ngIf="subtitleTemplateRef != null">
      <ng-container *ngTemplateOutlet="subtitleTemplateRef; context:{results: insuranceResults$ | async}"
      ></ng-container>
    </div>
  </header>

  <div class="subheader" *ngIf="subheaderTemplateRef != null">
    <ng-container *ngTemplateOutlet="subheaderTemplateRef"></ng-container>
  </div>

  <div class="results-list">

    <div *ngIf="contentTemplateRef; else defaultContent">
      <ng-container *ngTemplateOutlet="contentTemplateRef; context:{results: insuranceResults$ | async}"
      ></ng-container>
    </div>

    <ng-template #defaultContent>
      <div class="loading-panel" *ngIf="(loading$ | async) ">
        Chargement...
      </div>

      <div [hidden]="loading$ | async" class="list">
        <div *ngIf="(insuranceResults$ |async)?.count > 0; else emptyResults">

          <div *ngFor="let subscription of (insuranceResults$ | async)?.list" class="list-item">
            <cf-insurance-subscription-item [insuranceSubscription]="subscription"
                                            [showDetails]="showEntryDetails"
                                            [showDetailsReserves]="showEntryReserve"
            ></cf-insurance-subscription-item>
          </div>

          <div
            *ngIf="showFamilyDetailsLink && ( alwaysShowFamilyDetailsLink ||  (insuranceResults$ | async)?.count > (insuranceResults$ | async)?.list.length)">
            <a [routerLink]="['/products', family]" i18n>
              {  (insuranceResults$ | async)?.count, plural,
                =0 { Détails de la famille vide }
                =1 { Détails de la police }
                other { Détails des {{ (insuranceResults$ | async)?.count }} polices }
                }
            </a>
          </div>
        </div>

        <ng-template #emptyResults>
          <div class="empty-category">
            <p>
              Aucun produit dans cette catégorie

              <a [routerLink]="['/mandate', {family:family}]"
                 class="mandate-link lifeislife-button-link mandate-request-action-button"
              >
                <span i18n>Transférer</span>
              </a>
            </p>


            <!--            <a [routerLink]="['/mandate', {family:family}]"-->
            <!--               *ngIf="showMandateRequestButton"-->
            <!--               class="lifeislife-button-link"-->
            <!--            >-->
            <!--              <span i18n>Transférer</span>-->
            <!--            </a>-->
          </div>
        </ng-template>

      </div>

    </ng-template>
  </div>


  <div class="action-link">
    <a class="sourcing-link" (click)="onNewSourcingRequestClick(family)"
       *ngIf="showFamilyRequestLink"
    >
      Je souhaite plus d'info ou transférer mes polices {{ familyLabel }}
    </a>

    <a [routerLink]="['/mandate', {family:family}]"
       class="link mandate-request-action-button"
       *ngIf="showMandateRequestButton && (insuranceResults$ | async)?.count > 0"
    >
      <span i18n>Transférer d'autres polices {{ familyLabel }}</span>
    </a>
  </div>

</div>
